import Header from "../Header";
import MainPage from "./MainPage";
import Footer from "../Footer";
import { useEffect } from "react";

// This is the main page of the application
function Index() {
  useEffect(() => {
    const event = new Event("reactRendered");
    window.dispatchEvent(event);
  }, []);

  return (
    <>
      <Header />

      <MainPage />

      <Footer />
    </>
  );
}

export default Index;
